export default __webpack_public_path__ + "static/service-image-7f07ecaedbaabb48ce704da126e03195.jpg";